<ng-container *transloco="let _t">


<div class="row details" *ngIf="incident">
  <div class="col-4">
  	<h2>
      <span [ngClass]="{
      'grav1':incident.gravity==1,
      'grav2':incident.gravity==2,
      'grav3':incident.gravity==3
    }">{{incident.gravity}}</span>
      {{incident.nature}}
    </h2>
  	<p class="text-right"><small>
  		Signalé le : <em>{{incident.dtwrite.date | date:'short':undefined:'fr-FR' | replace:" ":"\n à "}}</em><br>
  	</small></p>
    <p></p>

    <h3>{{ _t('incident-sheet-h3-0') }}</h3>
    <p>{{incident.dtfacts.date | date:'short':undefined:'fr-FR' | replace:" ":"\n à "}}</p>
    <p></p>

    <h3>{{ _t('incident-sheet-h3-1') }}</h3>
    <p>
      {{incident.redactor.name}} <br>
      {{incident.redactor.phone}} <br>
      <a [href]="'mailto:'+incident.redactor.email">{{incident.redactor.email}}</a>
    </p>
    <p></p>

  	<h3>{{ _t('incident-sheet-h3-2') }}</h3>
  	<p>{{incident.description}}</p>

  </div>

  <div class="col-4">
    <!--status-->
    <h3 class="mat-button-toggle-group-title">{{ _t('incident-sheet-h3-3') }} </h3>
    <mat-button-toggle-group name="status" [(ngModel)]="incident.status" color="accent" (change)="save()">
      <mat-button-toggle value="Nouveau" > {{ _t('incident-sheet-mat-button-toggle-0') }} </mat-button-toggle>
      <mat-button-toggle value="En cours" > {{ _t('incident-sheet-mat-button-toggle-1') }} </mat-button-toggle>
      <mat-button-toggle value="Résolu" > {{ _t('incident-sheet-mat-button-toggle-2') }} </mat-button-toggle>
    </mat-button-toggle-group>


    <h3>{{ _t('incident-sheet-h3-4') }}</h3>
    <p>{{incident.measures}}</p>


    <h3>{{ _t('incident-sheet-h3-5') }}</h3>
    <form class="form-instructions">
      <mat-form-field>
          <label>{{ _t('incident-sheet-label-0') }}</label>
          <textarea matInput name="instructions" [(ngModel)]="incident.instructions" >
          </textarea>
      </mat-form-field>
    </form>
    <p class="text-right">
      <button mat-raised-button color="basic" (click)='save();'>
        <mat-icon>save</mat-icon> {{ _t('incident-sheet-button-0') }}</button>
    </p>
<!-- TODO : discussions
    <h3>{{ _t('incident-sheet-h3-6') }}</h3>
    <p>{{ _t('incident-sheet-p-6') }}</p>
-->
  </div>

  <div class="col-4 picdiv">
    <h3>{{ _t('incident-sheet-h3-7') }}</h3>
    <cmat-picture
      [src]="incident.photo" 
      [alt]="'Photo de l\'incident'" 
      [uploadable]="false"></cmat-picture>
  </div>

</div>

</ng-container>